// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"37":"23b816f5","54":"23b816f5","188":"eee709ad","321":"f8150da3","345":"96fb974d","365":"57c1de11","599":"eee709ad","843":"0cbbb371","861":"23b816f5"}[chunkId] + ".chunk.css";
};